import { GridColumnVisibilityModel, GridFilterModel } from '@mui/x-data-grid-premium'

// ── Service line config ──────────────────────────────────────────────────────

export const SERVICE_LINES: Record<string, { label: string; color: string }> = {
  seo: { label: 'SEO', color: '#4caf50' },
  ppc: { label: 'PPC', color: '#ff9800' },
  web: { label: 'Web', color: '#2196f3' },
  social: { label: 'Social', color: '#e91e63' },
  creative: { label: 'Creative', color: '#9c27b0' },
  emm: { label: 'Email', color: '#00bcd4' },
  ana: { label: 'Analytics', color: '#607d8b' },
  ux: { label: 'UX', color: '#795548' },
  int: { label: 'Integration', color: '#3f51b5' },
}

export const SERVICE_LINE_OPTIONS = Object.entries(SERVICE_LINES).map(([value, { label }]) => ({
  value,
  label,
}))
export const STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Deprecated', label: 'Deprecated' },
]

export const BOOLEAN_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
]
export const CATEGORY_OPTIONS = [
  { value: 'Web Development', label: 'Web Development' },
  { value: 'UX/Design', label: 'UX/Design' },
  { value: 'SEO', label: 'SEO' },
  { value: 'Paid Media', label: 'Paid Media' },
  { value: 'Analytics', label: 'Analytics' },
  { value: 'Integration', label: 'Integration' },
  { value: 'Email Marketing', label: 'Email Marketing' },
  { value: 'Social Media', label: 'Social Media' },
  { value: 'Creative', label: 'Creative' },
]
export const TA_TYPE_OPTIONS = [
  { value: 'Web Development', label: 'Web Development', color: '#2196f3' },
  { value: 'User Experience', label: 'User Experience', color: '#795548' },
  { value: 'Paid Media', label: 'Paid Media', color: '#ff9800' },
  { value: 'Mock-Up', label: 'Mock-Up', color: '#795548' },
  { value: 'Testing/Quality Assurance', label: 'Testing/Quality Assurance', color: '#78909c' },
  { value: 'Competitive Analysis', label: 'Competitive Analysis', color: '#607d8b' },
  { value: 'On-Page Optimization', label: 'On-Page Optimization', color: '#4caf50' },
  { value: 'Shopping Feed Management', label: 'Shopping Feed Management', color: '#ff9800' },
  { value: 'Page Speed & Website Performance', label: 'Page Speed & Website Performance', color: '#2196f3' },
  { value: 'Strategy Implementation', label: 'Strategy Implementation', color: '#3f51b5' },
  { value: 'Analytics', label: 'Analytics', color: '#607d8b' },
  { value: 'Content Development & Expansion', label: 'Content Development & Expansion', color: '#4caf50' },
  { value: 'Strategy Development', label: 'Strategy Development', color: '#3f51b5' },
  { value: 'SEO', label: 'SEO', color: '#4caf50' },
  { value: 'Results Review', label: 'Results Review', color: '#607d8b' },
  { value: 'Social Media', label: 'Social Media', color: '#e91e63' },
  { value: 'XML Sitemap', label: 'XML Sitemap', color: '#4caf50' },
  { value: 'Creative Production', label: 'Creative Production', color: '#9c27b0' },
  { value: 'Local Optimization Entries', label: 'Local Optimization Entries', color: '#4caf50' },
  { value: 'A/B Testing & Quality Assurance', label: 'A/B Testing & Quality Assurance', color: '#78909c' },
  { value: 'Technical SEO', label: 'Technical SEO', color: '#4caf50' },
  { value: 'Internal Linking', label: 'Internal Linking', color: '#4caf50' },
  { value: 'Client Request', label: 'Client Request', color: '#78909c' },
  { value: 'Reporting', label: 'Reporting', color: '#607d8b' },
  {
    value: 'Google Business Profile - Local Pack Optimization',
    label: 'Google Business Profile - Local Pack Optimization',
    color: '#4caf50',
  },
  { value: 'Content Optimization', label: 'Content Optimization', color: '#4caf50' },
  { value: 'A/B Test Email & Communication', label: 'A/B Test Email & Communication', color: '#00bcd4' },
  { value: 'Client Interaction - Email', label: 'Client Interaction - Email', color: '#00bcd4' },
  { value: 'EMM Service Set-up', label: 'EMM Service Set-up', color: '#00bcd4' },
  { value: 'SEO Service Set-up - Keyword Research', label: 'SEO Service Set-up - Keyword Research', color: '#4caf50' },
  { value: 'Custom Backlink Building', label: 'Custom Backlink Building', color: '#4caf50' },
  { value: 'Image Optimization', label: 'Image Optimization', color: '#9c27b0' },
  { value: 'Web Editing Agreement', label: 'Web Editing Agreement', color: '#2196f3' },
  { value: 'Large HTML Sitemaps', label: 'Large HTML Sitemaps', color: '#4caf50' },
  { value: 'Strategy Compilation', label: 'Strategy Compilation', color: '#3f51b5' },
  { value: 'Links', label: 'Links', color: '#4caf50' },
  { value: 'Prospect Audits', label: 'Prospect Audits', color: '#607d8b' },
  { value: 'Data Analysis', label: 'Data Analysis', color: '#607d8b' },
  { value: 'Video Optimization', label: 'Video Optimization', color: '#9c27b0' },
]
export const TA_CATEGORY_OPTIONS = [
  { value: 'Development', label: 'Development', color: '#2196f3' },
  { value: 'On-Page Optimization', label: 'On-Page Optimization', color: '#4caf50' },
  { value: 'Paid Advertising', label: 'Paid Advertising', color: '#ff9800' },
  { value: 'Research & Strategy', label: 'Research & Strategy', color: '#3f51b5' },
  { value: 'Other', label: 'Other', color: '#78909c' },
  { value: 'Shopping & Social', label: 'Shopping & Social', color: '#e91e63' },
  { value: 'Reporting', label: 'Reporting', color: '#607d8b' },
  { value: 'Organic Search', label: 'Organic Search', color: '#4caf50' },
  { value: 'Social', label: 'Social', color: '#e91e63' },
  { value: 'Conversion Optimization', label: 'Conversion Optimization', color: '#795548' },
  { value: 'Creative', label: 'Creative', color: '#9c27b0' },
  { value: 'Off-Page Optimization', label: 'Off-Page Optimization', color: '#4caf50' },
  { value: 'Account Management', label: 'Account Management', color: '#3f51b5' },
  { value: 'Setups', label: 'Setups', color: '#00bcd4' },
  { value: 'Tickets', label: 'Tickets', color: '#78909c' },
  { value: 'Results & Interactions', label: 'Results & Interactions', color: '#607d8b' },
]
export const DEPARTMENT_OPTIONS = [
  { value: 'Hosting', label: 'Hosting', color: '#2196f3' },
  { value: 'UX Strategy', label: 'UX Strategy', color: '#795548' },
  { value: 'SEO', label: 'SEO', color: '#4caf50' },
  { value: 'Setup Fee', label: 'Setup Fee', color: '#78909c' },
  { value: 'Analytics Implementation', label: 'Analytics Implementation', color: '#607d8b' },
  { value: 'SEO Content', label: 'SEO Content', color: '#4caf50' },
  { value: 'Website', label: 'Website', color: '#2196f3' },
  { value: 'Integrations', label: 'Integrations', color: '#3f51b5' },
  { value: 'Email Services', label: 'Email Services', color: '#00bcd4' },
  { value: 'Search', label: 'Search', color: '#ff9800' },
  { value: 'Paid Media', label: 'Paid Media', color: '#ff9800' },
  { value: 'Organic', label: 'Organic', color: '#4caf50' },
  { value: 'SMM', label: 'SMM', color: '#e91e63' },
  { value: 'Graphic Design', label: 'Graphic Design', color: '#9c27b0' },
  { value: 'Management Fee', label: 'Management Fee', color: '#78909c' },
  { value: 'Website Build', label: 'Website Build', color: '#2196f3' },
  { value: 'Analytics', label: 'Analytics', color: '#607d8b' },
  { value: 'Social', label: 'Social', color: '#e91e63' },
  { value: 'Videography', label: 'Videography', color: '#9c27b0' },
  { value: 'Retainer', label: 'Retainer', color: '#78909c' },
  { value: 'Analytics Reporting', label: 'Analytics Reporting', color: '#607d8b' },
  { value: 'Web Project Management', label: 'Web Project Management', color: '#2196f3' },
  { value: 'Discovery', label: 'Discovery', color: '#3f51b5' },
  { value: 'Web Services', label: 'Web Services', color: '#2196f3' },
  { value: 'Troubleshooting', label: 'Troubleshooting', color: '#78909c' },
  { value: 'Creative', label: 'Creative', color: '#9c27b0' },
  { value: 'Display', label: 'Display', color: '#ff9800' },
  { value: 'People', label: 'People', color: '#3f51b5' },
  { value: 'Photography', label: 'Photography', color: '#9c27b0' },
  { value: 'Ecommerce', label: 'Ecommerce', color: '#2196f3' },
  { value: 'Implementation', label: 'Implementation', color: '#3f51b5' },
  { value: 'Front End Development', label: 'Front End Development', color: '#2196f3' },
  { value: 'Research', label: 'Research', color: '#3f51b5' },
  { value: 'Audio', label: 'Audio', color: '#9c27b0' },
  { value: 'Equipment', label: 'Equipment', color: '#78909c' },
  { value: 'Reporting', label: 'Reporting', color: '#607d8b' },
  { value: 'Video', label: 'Video', color: '#9c27b0' },
  { value: 'Consulting', label: 'Consulting', color: '#3f51b5' },
  { value: 'UX Design', label: 'UX Design', color: '#795548' },
]
export const DELIVERY_ROLE_OPTIONS = [
  { value: 'Web Developer', label: 'Web Developer' },
  { value: 'UX Strategist', label: 'UX Strategist' },
  { value: 'SEO Strategist', label: 'SEO Strategist' },
  { value: 'Paid Media Specialist', label: 'Paid Media Specialist' },
  { value: 'Analytics Specialist', label: 'Analytics Specialist' },
  { value: 'Email Marketing Specialist', label: 'Email Marketing Specialist' },
  { value: 'Paid Media Strategist', label: 'Paid Media Strategist' },
  { value: 'SEO Specialist', label: 'SEO Specialist' },
  { value: 'Social Media Specialist', label: 'Social Media Specialist' },
  { value: 'Creative Specialist', label: 'Creative Specialist' },
  { value: 'Automation Specialist', label: 'Automation Specialist' },
  { value: 'Reporting Specialist', label: 'Reporting Specialist' },
  { value: 'Project Manager', label: 'Project Manager' },
  { value: 'Project Coordinator', label: 'Project Coordinator' },
  { value: 'UX Designer', label: 'UX Designer' },
]
export const EDITABLE_FIELDS = [
  { key: 'title', label: 'Service Name', required: true },
  { key: 'sku', label: 'SKU', required: true },
  { key: 'service_line', label: 'Service Line', type: 'select', options: SERVICE_LINE_OPTIONS, required: true },
  { key: 'category_name', label: 'Category', type: 'select', options: CATEGORY_OPTIONS, required: true },
  { key: 'subcategory', label: 'Subcategory', type: 'select', options: DEPARTMENT_OPTIONS },
  { key: 'points', label: 'Points', type: 'number' },
  { key: 'price', label: 'Price', type: 'number' },
  { key: 'cost', label: 'Cost', type: 'number' },
  { key: 'margin', label: 'Margin %', type: 'number' },
  { key: 'estimated_hours', label: 'Estimated Hours', type: 'number' },
  { key: 'qty', label: 'Default Quantity', type: 'number' },
  { key: 'delivery_role', label: 'Delivery Role', type: 'select', options: DELIVERY_ROLE_OPTIONS },
  { key: 'owner', label: 'Owner' },
  { key: 'ta_type', label: 'TA Type', type: 'select', options: TA_TYPE_OPTIONS },
  { key: 'ta_category', label: 'TA Category', type: 'select', options: TA_CATEGORY_OPTIONS },
  { key: 'variant', label: 'Variant' },
  { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS },
  { key: 'ai_enhanced', label: 'AI Enhanced', type: 'select', options: BOOLEAN_OPTIONS },
  { key: 'description', label: 'Description', multiline: true },
] as Array<{
  key: string
  label: string
  required?: boolean
  type?: string
  options?: { value: string; label: string }[]
  multiline?: boolean
}>

export const pinnedColumns = { left: [], right: ['actions'] }
export const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
}
export const defaultColumnOrder: string[] = [
  'title',
  'sku',
  'ta_type',
  'ta_category',
  'price',
  'margin',
  'estimated_hours',
  'points',
  'service_line',
  'delivery_role',
  'category_name',
  'subcategory',
  'cost',
  'ai_enhanced',
  'status',
  'actions',
]
export const defaultVisibilityModel: GridColumnVisibilityModel = {
  category_name: false, // Hide tree-specific columns
}
